import React from "react";
import PropTypes from "prop-types";

import ThemeCard from "./ThemeCard";

const ThemesList = ({ themes }) => {
  return Object.entries(themes).map(([key, theme]) => {
    return <ThemeCard theme={theme} themeId={key} key={key} />;
  });
};

ThemesList.propTypes = {
  themes: PropTypes.object.isRequired
};

ThemesList.defaultProps = {
  themes: {}
};

export default ThemesList;
